import authorizationService from '../../jscomponents/AuthorizationService';

const IfAuthorized = ({ policy, children }) => {
    console.log(`IfAuthorized.render isAuthServInit:${authorizationService.isInitialized} policy:${policy}`);
    return authorizationService.isInitialized && authorizationService.authorize(policy) && children;
};

export default IfAuthorized;